import { render } from "./app-logo.vue?vue&type=template&id=5747017a"
const script = {}

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/components/image/app-logo.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5747017a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5747017a', __exports__)) {
    console.log('reload')
    api.reload('5747017a', __exports__)
  }
  
  module.hot.accept("./app-logo.vue?vue&type=template&id=5747017a", () => {
    console.log('re-render')
    api.rerender('5747017a', render)
  })

}


export default __exports__